import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';

export const tableRoutes: Routes = [
  {
    path: 'tables',
    canActivate: [authGuard, clientIdGuard],
    loadComponent: () =>
      import('../components/tables/tables.component').then(
        (m) => m.TablesComponent
      ),
    children: [
      {
        path: 'clients',
        loadComponent: () =>
          import('../components/tables/client/client.component').then(
            (m) => m.ClientComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'data-sources',
        loadComponent: () =>
          import(
            '../components/tables/data-sources/data-sources.component'
          ).then((m) => m.DataSourcesComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'data-internal-use',
        loadComponent: () =>
          import(
            '../components/tables/data-internal-use/data-internal-use.component'
          ).then((m) => m.DataInternalUseComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'product-purchased',
        loadComponent: () =>
          import(
            '../components/tables/product-purchased/product-purchased.component'
          ).then((m) => m.ProductPurchasedComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'chargebacks',
        loadComponent: () =>
          import('../components/tables/chargebacks/chargebacks.component').then(
            (m) => m.ChargebacksComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'merchants',
        loadComponent: () =>
          import('../components/tables/merchant/merchant.component').then(
            (m) => m.MerchantComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'merchant-services',
        loadComponent: () =>
          import(
            '../components/tables/merchant-services/merchant-services.component'
          ).then((m) => m.MerchantServicesComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'requests',
        loadComponent: () =>
          import('../components/tables/requests/requests.component').then(
            (m) => m.RequestsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'descriptors',
        loadComponent: () =>
          import('../components/tables/descriptors/descriptors.component').then(
            (m) => m.DescriptorsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'billing-client-service',
        loadComponent: () =>
          import(
            '../components/tables/billing-client-services/billing-client-services.component'
          ).then((m) => m.BillingClientServicesComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'alerts-action-queue',
        loadComponent: () =>
          import(
            '../components/tables/alerts-action-queue/alerts-action-queue.component'
          ).then((m) => m.AlertsActionQueueComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'client-trx-data',
        loadComponent: () =>
          import(
            '../components/tables/client-trx-data/client-trx-data.component'
          ).then((m) => m.ClientTrxDataComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('../components/tables/summary/summary.component').then(
            (m) => m.SummaryComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'merchant-data-sources',
        loadComponent: () =>
          import(
            '../components/tables/merchant-data-source/merchant-data-source.component'
          ).then((m) => m.MerchantDataSourceComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      
    ],
  },
];
